(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hz-header-tools"] && !Shopify.designMode) return;
  try {
    (function () {
if (window.hzToolsReady) return;
window.hzToolsReady = true;
const key = 'hz-favorites-v1';
let entries = [];
const ui = () => document.getElementById('hz-tools');
function read() {
try { const value = JSON.parse(localStorage.getItem(key) || '[]'); entries = Array.isArray(value) ? value.filter(p => p && typeof p.title === 'string' && typeof p.url === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+$/i.test(p.url)).slice(0,100) : []; } catch { entries = []; }
}
function paint() {
document.querySelectorAll('[data-hz-count]').forEach(el => {el.textContent = entries.length; el.hidden = !entries.length;});
document.querySelectorAll('[data-hz-save]').forEach(el => {
const saved = entries.some(p => p.url === el.dataset.url);
el.setAttribute('aria-pressed', String(saved));
el.querySelector('span').textContent = saved ? ui().dataset.added : ui().dataset.add;
});
const list = document.querySelector('[data-hz-list]'); if (!list) return;
list.replaceChildren();
entries.forEach(p => {
const li = document.createElement('li'), a = document.createElement('a'), b = document.createElement('button');
a.href = p.url; a.textContent = p.title; b.type = 'button'; b.textContent = ui().dataset.remove;
b.addEventListener('click', () => { entries = entries.filter(x => x.url !== p.url); paint(); save(); document.querySelector('[data-hz-close]').focus(); });
li.append(a,b); list.append(li);
});
document.querySelector('[data-hz-status]').textContent = entries.length ? '' : ui().dataset.empty;
}
function save() { try { localStorage.setItem(key, JSON.stringify(entries)); } catch { document.querySelector('[data-hz-status]').textContent = ui().dataset.error; } }
document.addEventListener('click', e => {
const open = e.target.closest('[data-hz-open]');
if(open) { read(); paint(); document.getElementById(open.dataset.hzOpen).showModal(); return; }
const close = e.target.closest('[data-hz-close]'); if(close) { close.closest('dialog').close(); return; }
const btn = e.target.closest('[data-hz-save]');
if(btn) { read(); const url=btn.dataset.url;
if(entries.some(p=>p.url===url)) entries=entries.filter(p=>p.url!==url);
else if(entries.length < 100) entries.push({url, title:btn.dataset.title});
paint(); save();
}
});
document.addEventListener('submit', e => {
if(!e.target.matches('[data-hz-coupon]'))return;
e.preventDefault(); const code = new FormData(e.target).get('code').trim(); if(!code)return;
window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(e.target.dataset.cart));
});
window.addEventListener('storage', () => {read();paint();});
document.addEventListener('shopify:section:load', () => {read();paint();});
function init(){read();paint();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
  } catch(e) { console.error(e); }
})();

})();
